/**
 * Tooltip toggle functionality
 *
 * @package PPD
 * @since   1.0.0
 */

/**
 * Import dependencies.
 */
import $ from "jquery";

// Click functionality for the commitment tooltips.
$(document).on("click tap touchstart", function (e) {
	if (
		$(e.target).is(
			".result-time-commitment-cell .btn-tooltip, .result-time-commitment-cell .btn-tooltip *"
		)
	) {
		if (
			$(e.target)
				.closest(".result-time-commitment-cell")
				.hasClass("tooltip-visible")
		) {
			$(e.target)
				.closest(".result-time-commitment-cell")
				.attr("class", "result-time-commitment-cell trial-box tooltip-hidden");
			//alert("toggled off");
		} else {
			$(e.target)
				.closest(".result-time-commitment-cell")
				.addClass("tooltip-visible");
			//alert("toggled on");
		}
	} else {
		if ($(".result-time-commitment-cell").hasClass("tooltip-visible")) {
			if (
				!$(e.target).is(".time-commitment-details, .time-commitment-details *")
			) {
				$(".result-time-commitment-cell").removeClass("tooltip-visible");
				//alert("removed");
			}
		}
	}
});

// Click functionality for the requirement tooltips as well.
$(document).on("click tap touchstart", function (e) {
	if (
		$(e.target).is(
			".trial-requirement .btn-tooltip, .trial-requirement .btn-tooltip *"
		)
	) {
		$(e.target).closest(".trial-requirement").toggleClass("tooltip-visible");
	} else {
		if ($(".trial-requirement").hasClass("tooltip-visible")) {
			if (
				!$(e.target).is(
					".trial-requirement-details, .trial-requirement-details *"
				)
			) {
				$(".trial-requirement").removeClass("tooltip-visible");
			}
		}
	}
});
